export class LabelInput {
  id: string;
  externalId: string;
  scopedName: string;
  name: string;
  scope: string;
  color: string;
  description: string;

  constructor(payload?: any) {
    if (payload) {
      this.id = payload.id;
      this.externalId = payload.externalId;
      this.name = payload.name;
      this.scope = payload.scope;
      this.color = payload.color;
      this.description = payload.description;
    }
  }

}
